 <template>
  <div class="outlet-page">
    <!-- 表格 -->
    <div class="outlet-container">
      <div class="outlet-panel">
    <div class="outlet-toolbar">
    <el-form :inline="true" :model="params" class="outlet-search" size="small" @submit.native.prevent="checkData">
      <el-form-item label="网点名称"><el-input v-model="params.regionName" placeholder="请输入网点名称" clearable @keyup.enter.native="checkData" /></el-form-item>
      <el-form-item><el-button type="primary" size="mini" @click="checkData">查询</el-button><el-button size="mini" @click="reset">重置</el-button></el-form-item>
    </el-form>

        <el-button type="primary" size="small" @click="add()" v-show="authorization('/home-admin/routineManage/region-manage/add')">新增</el-button>
    </div>
        <el-table :data="tableData" stripe class="outlet-table" height="100%" size="small" :header-cell-style="{'background-color':'#84aace4a','color':'#343333','text-align':'center'}" :cell-style="{'text-align':'center'}">
          <el-table-column prop="regionName" label="网点名"></el-table-column>
          <el-table-column label="网点师傅数量" width="140">
            <template slot-scope="scope">
              <el-button v-if="authorization('/home-admin/routineManage/region-manage/technicians')" type="text" @click="openTechnicians(scope.row, true)">{{ scope.row.technicianCount || 0 }}</el-button>
              <span v-else>{{ scope.row.technicianCount || 0 }}</span>
            </template>
          </el-table-column>
            <el-table-column prop="orderIndex" label="排序"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="outlet-actions">
              <el-button v-if="authorization('/home-admin/routineManage/region-manage/technicians')" type="text" size="mini" @click="openTechnicians(scope.row, false)">师傅配置</el-button>
              <el-button v-if="authorization('/home-admin/routineManage/region-manage/edit')" type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
              <el-popconfirm v-if="authorization('/home-admin/routineManage/region-manage/del')" title="确认删除吗？" @confirm="deleteRegion(scope.row)">
                <el-button slot="reference" type="text" size="mini" class="outlet-delete">删除</el-button>
              </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="outlet-pagination">
          <el-pagination background :page-sizes="sizes" layout="total,sizes,prev,pager,next" :current-page="params.page" :page-size="params.size" :total="total" @current-change="handleCurrentChange" @size-change="sizeChange"></el-pagination>
        </div>
      </div>
    </div>

    <el-drawer :title="technicianTitle" :visible.sync="technicianVisible" size="min(620px, 94vw)" :wrapper-closable="false" :before-close="closeTechnicians" custom-class="outlet-technician-drawer">
      <div class="technician-body" v-loading="technicianLoading">
        <div class="technician-sticky">
          <el-select v-if="!technicianReadOnly" v-model="technicianIds" multiple filterable collapse-tags placeholder="请选择在职师傅" :disabled="technicianLoading || technicianSaving" class="technician-select">
            <el-option v-for="item in technicianOptions" :key="item.id" :label="`${item.userName}（${item.account}）`" :value="item.id" />
          </el-select>
          <el-input v-model="technicianSearch" placeholder="搜索师傅姓名或账号" clearable size="small" :class="{ 'technician-search-after-select': !technicianReadOnly }" />
        </div>
        <el-table :data="technicianReadOnly ? filteredTechnicianMembers : filteredSelectedTechnicians" size="small" empty-text="暂无网点师傅" style="width:100%;margin-top:16px">
          <el-table-column label="师傅姓名" min-width="120">
            <template slot-scope="scope"><span :class="technicianRowClass(scope.row)"><span v-if="isAdded(scope.row.id)" class="technician-plus">＋</span>{{ scope.row.userName }}</span></template>
          </el-table-column>
          <el-table-column label="账号" min-width="140"><template slot-scope="scope"><span :class="technicianRowClass(scope.row)">{{ scope.row.account }}</span></template></el-table-column>
          <el-table-column v-if="!technicianReadOnly" label="操作" width="80">
            <template slot-scope="scope"><el-button type="text" size="mini" :class="isRemoved(scope.row.id) ? '' : 'outlet-delete'" :disabled="technicianSaving" @click="toggleTechnician(scope.row.id)">{{ isRemoved(scope.row.id) ? '撤销删除' : '删除' }}</el-button></template>
          </el-table-column>
        </el-table>
        <el-alert v-if="technicianLoadFailed && !technicianLoading" title="加载失败，请关闭后重试" type="error" :closable="false" />
      </div>
      <div class="technician-footer">
        <el-button size="small" :disabled="technicianSaving || technicianLoading" @click="technicianVisible=false">{{ technicianReadOnly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!technicianReadOnly" type="primary" size="small" :loading="technicianSaving" :disabled="technicianLoading || technicianLoadFailed" @click="previewTechnicianChanges">保存</el-button>
      </div>
    </el-drawer>
    <el-dialog title="确认保存师傅配置" :visible.sync="technicianConfirmVisible" width="min(520px, 94vw)" append-to-body :close-on-click-modal="false" :close-on-press-escape="!technicianSaving" :show-close="!technicianSaving">
      <p>本次新增 {{ addedTechnicians.length }} 人，删除 {{ removedTechnicians.length }} 人。</p>
      <el-collapse v-model="technicianConfirmExpanded">
        <el-collapse-item title="查看变动明细" name="details">
          <div v-if="addedTechnicians.length" class="change-add">新增：<span v-for="item in addedTechnicians" :key="'add-'+item.id">{{ item.userName }}（{{ item.account }}） </span></div>
          <div v-if="removedTechnicians.length" class="change-remove">删除：<span v-for="item in removedTechnicians" :key="'remove-'+item.id">{{ item.userName }}（{{ item.account }}） </span></div>
        </el-collapse-item>
      </el-collapse>
      <span slot="footer"><el-button size="small" :disabled="technicianSaving" @click="technicianConfirmVisible=false">取消</el-button><el-button type="primary" size="small" :loading="technicianSaving" @click="saveTechnicians">确认保存</el-button></span>
    </el-dialog>
    <!-- 弹出层 -->
    <el-dialog title="新增" :visible.sync="dialogFormAdd" width="700px" :close-on-click-modal="false">
      <el-form :model="regionManageArray" :rules="rules" ref="regionManageArray" label-width="160px" size="small" style="width:600px">
  <!--   <el-form-item label="网点编号" prop="regionCode">
            <el-input v-model="regionManageArray.regionCode" autocomplete="off"></el-input>
          </el-form-item>-->
          <el-form-item label="网点名" prop="regionName">
            <el-input v-model="regionManageArray.regionName"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="orderIndex">
            <el-input-number v-model="regionManageArray.orderIndex" :min="0"></el-input-number>
          </el-form-item>
        </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormAdd = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addSubMit('regionManageArray')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹出层 -->
    <el-dialog title="编辑" :visible.sync="dialogFormEdit" width="700px" :close-on-click-modal="false">
      <el-form :model="regionManageArray" :rules="rules" ref="regionManageArray" label-width="160px" size="small" style="width:600px">
  <!--   <el-form-item label="网点编号" prop="regionCode">
            <el-input v-model="regionManageArray.regionCode" autocomplete="off"></el-input>
          </el-form-item>-->
          <el-form-item label="网点名" prop="regionName">
            <el-input v-model="regionManageArray.regionName"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="orderIndex">
            <el-input-number v-model="regionManageArray.orderIndex" :min="0"></el-input-number>
          </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormEdit = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="editSubMit('regionManageArray')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { authorization } from '../../../authorization/authorization'
export default {
  data() {
    return {
      technicianVisible: false, technicianLoading: false, technicianSaving: false, technicianLoadFailed: false,
      technicianOriginalIds: [], technicianConfirmVisible: false, technicianConfirmExpanded: [],
      technicianReadOnly: false, technicianMembers: [], technicianTitle: '师傅配置', technicianRegionId: null, technicianSearch: '', technicianOptions: [], technicianIds: [],
      dialogFormAdd: false,
      dialogFormEdit: false,
      tableData: [],
      params: {
        regionCode: "",
        regionName: "",
        page: 1,
        size: 50,
      },
      regionManageArray: {
        id:"",
        regionCode: "",
        regionName: "",
        orderIndex:1
      },
      rules: {
        /*regionCode:[
          { required: true, message: '请输入网点编号', trigger: 'blur' },
        ],*/
        regionName:[
          { required: true, message: '请输入网点名', trigger: 'blur' },
        ],
         orderIndex:[
          { required: true, message: '请输入排序编码', trigger: 'blur' },
        ],
      },
      total: 0,
      sizes: [10, 15, 20, 50],
    };
  },
  created() {
    this.queryRegionManageList();
  },
  computed: {
    filteredTechnicianMembers() {
      const text = this.technicianSearch.trim().toLowerCase();
      return this.technicianMembers.filter(item => `${item.userName || ''} ${item.account || ''}`.toLowerCase().includes(text));
    },
    filteredSelectedTechnicians() {
      const text = this.technicianSearch.trim().toLowerCase();
      return this.selectedTechnicians.filter(item => `${item.userName || ''} ${item.account || ''}`.toLowerCase().includes(text));
    },
    addedTechnicians() { return this.technicianOptions.filter(item => this.isAdded(item.id)); },
    removedTechnicians() { return this.technicianOptions.filter(item => this.isRemoved(item.id)); },
    selectedTechnicians() {
      const displayed = new Set([...this.technicianIds, ...this.technicianOriginalIds]);
      return this.technicianOptions.filter(item => displayed.has(item.id));
    },
  },
  methods: {
    isAdded(id) { return !this.technicianReadOnly && this.technicianIds.includes(id) && !this.technicianOriginalIds.includes(id); },
    isRemoved(id) { return !this.technicianReadOnly && this.technicianOriginalIds.includes(id) && !this.technicianIds.includes(id); },
    technicianRowClass(item) { return { 'technician-added': this.isAdded(item.id), 'technician-removed': this.isRemoved(item.id) }; },
    toggleTechnician(id) {
      this.technicianIds = this.isRemoved(id) ? [...this.technicianIds, id] : this.technicianIds.filter(value => value !== id);
    },
    previewTechnicianChanges() {
      if (!this.addedTechnicians.length && !this.removedTechnicians.length) { this.saveTechnicians(); return; }
      this.technicianConfirmExpanded = []; this.technicianConfirmVisible = true;
    },
    closeTechnicians(done) { if (!this.technicianSaving && !this.technicianLoading) done(); },
    async openTechnicians(row, readOnly = false) {
      this.technicianReadOnly = readOnly; this.technicianMembers = [];
      this.technicianRegionId = row.id; this.technicianTitle = `${row.regionName} · ${readOnly ? '网点师傅' : '师傅配置'}`;
      this.technicianSearch = ''; this.technicianOptions = []; this.technicianIds = []; this.technicianOriginalIds = []; this.technicianConfirmVisible = false;
      this.technicianVisible = true; this.technicianLoading = true; this.technicianLoadFailed = true;
      try {
        const res = await this.axios.get(`/v1/web/region-manage/${row.id}/technicians`);
        if (res.data.code !== 200) throw new Error(res.data.message || '加载失败');
        this.technicianMembers = res.data.data.members || [];
        this.technicianOptions = res.data.data.options; this.technicianIds = res.data.data.selectedIds;
        this.technicianOriginalIds = [...this.technicianIds];
        this.technicianLoadFailed = false;
      } catch (e) { this.$message.error(e.message || '加载师傅配置失败'); }
      finally { this.technicianLoading = false; }
    },
    async saveTechnicians() {
      if (this.technicianSaving || this.technicianLoading || this.technicianLoadFailed) return;
      this.technicianSaving = true;
      try {
        const res = await this.axios.post(`/v1/web/region-manage/${this.technicianRegionId}/technicians`, this.technicianIds);
        if (res.data.code !== 200) throw new Error(res.data.message || '保存失败');
        this.$message.success('师傅配置已保存'); this.technicianConfirmVisible = false; this.technicianVisible = false; this.queryRegionManageList();
      } catch (e) { this.$message.error(e.message || '保存师傅配置失败'); }
      finally { this.technicianSaving = false; }
    },
    authorization,
    queryRegionManageList(){//获取网点列表
      this.axios({
        method: "get",
        url: "/v1/web/region-manage/select-region-list",
        params: this.params,
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    add(){//新增弹出层
      this.dialogFormAdd = true;
      this.regionManageArray = {};
    },
    addSubMit(formName){//新增提交
      this.$refs[formName].validate((valid) => {
        if (!valid) {
            return false
        }else {
          this.axios({
            method: "post",
            url: "/v1/web/region-manage/add-region",
            data: this.regionManageArray,
          }).then((res) => {
            if (res.data.code === 200) {
              console.log(res);
              this.dialogFormAdd = false;
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.queryRegionManageList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    edit(row){//编辑弹出层
      this.dialogFormEdit = true;
      this.regionManageArray = row;
    },
    editSubMit(formName){//编辑提交
      this.$refs[formName].validate((valid) => {
        if (!valid) {
            return false
        }else {
          this.axios({
            method: "post",
            url: "/v1/web/region-manage/update-region/" + this.regionManageArray.id,
            data: this.regionManageArray,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormEdit = false;
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.queryRegionManageList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    deleteRegion(row){//删除提交
      this.axios({
        method: "delete",
        url: "/v1/web/region-manage/delete-region/" + row.id,
      }).then((res) => {
        if (res.data.code === 200) {
          this.queryRegionManageList();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    dateFormat:function(row){
      if(row.createTime !== null && row.createTime !== undefined){
        return moment(row.createTime).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.queryRegionManageList();
    },
    sizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.queryRegionManageList();
    },
    checkData() {
      this.params.page = 1;
      this.queryRegionManageList();
    },
    reset() {
      this.params = { regionName: "", page: 1, size: this.params.size };
      this.queryRegionManageList();
    },
  },
};
</script>

<style scoped>
.outlet-toolbar { display:flex; align-items:center; justify-content:space-between; gap:12px; margin:0 20px; padding:12px 0 18px; }
.outlet-page { height:100%; min-height:0; overflow:hidden; }
.outlet-container { height:100%; min-height:0; padding:20px; box-sizing:border-box; }
.outlet-panel { height:100%; min-height:0; display:flex; flex-direction:column; background:#fff; border-radius:8px; padding-top:8px; box-sizing:border-box; }
.outlet-table { padding:0 20px; flex:1; min-height:0; }
.outlet-pagination { flex:none; padding:16px 20px; text-align:right; }
.outlet-search { margin:0; }
.outlet-search .el-form-item { margin-bottom:0; }
.outlet-delete { color:#f56c6c; }
.outlet-actions { display:flex; align-items:center; justify-content:center; gap:8px; }
.outlet-actions .el-button { margin:0; }
.technician-body { padding:0 24px 80px; overflow:auto; height:calc(100% - 75px); box-sizing:border-box; }
.technician-footer { position:absolute; bottom:0; left:0; right:0; padding:16px 24px; background:#fff; border-top:1px solid #ebeef5; display:flex; justify-content:flex-end; gap:8px; }
.technician-footer .el-button { margin:0; }
.technician-hint { color:#909399; font-size:13px; }
.technician-sticky { position:sticky; top:0; z-index:3; background:#fff; padding-bottom:4px; }
.technician-search-after-select { margin-top:12px; }
.technician-select { width:100%; }
.technician-added, .technician-plus, .change-add { color:#409eff; }
.technician-removed { color:#c0c4cc; text-decoration:line-through; }
.change-remove { color:#909399; margin-top:8px; }
.technician-plus { margin-right:4px; font-weight:600; }

</style>
